<template>
  <div class="error-503-page">
    <div class="dot"></div>
    <div class="err">
      <p>Oops!</p>
      <p>抱歉...</p>
    </div>
    <div class="congrats">
      <p>It seems you do not have permission for this action. Please contact your administrator or hit the "Home Page" button to continue.</p>
      <p>哎呀！您不能操作此模块，建议您联系管理员开通此模块的操作权限！</p>
    </div>
    <div class="try-again">
      <div class="try-btn" @click="tryAgain()">
        <p>回到首页/Home Page</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    tryAgain (page) {
      window.location.href = window.location.origin
    }
  }
}
</script>

<style lang="scss" scoped>
.error-503-page {
  padding: 30px;
  color: #000;
  font-family: Microsoft YaHei, "微软雅黑", Arial, Helvetica, sans-serif;

  p {
    margin: 0;
    font-weight: bold;
  }

  .dot {
    &::before {
      content: '';
      display: block;
      width: 75px;
      height: 75px;
      border-radius: 50%;
      background: #000;
    }
  }

  .err {
    margin-top: 30px;

    p:first-child {
      font-size: 90px;
      line-height: 1;
    }

    p:last-child {
      font-size: 20px;
    }
  }

  .congrats {
    margin-top: 30px;

    p:first-child {
      font-size: 28px;
    }

    p:last-child {
      font-size: 16px;
    }
  }

  .try-again {
    margin-top: 40px;
    margin-bottom: 40px;

    .try-btn {
      margin: auto;
      width: 220px;
      padding: 10px 5px;
      border: 4px solid #000;
      border-radius: 10px;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;

      p {
        font-size: 14px;
      }
    }
  }
}
</style>
